import Chart from 'chart.js';
import React, { Component } from 'react';

import type { ChartOptions } from 'chart.js';

interface IProps {
  id: string;
  options: ChartOptions;
  [key: string]: any;
}

class CustomChart extends Component<IProps, any> {
  private chart: any;

  constructor(props: any) {
    super(props);
    this.state = {
      id: props.id,
    };
  }

  custom = function (this: any, tooltipModel: any) {
    // Tooltip Element
    let tooltipEl = document.getElementById('chartjs-tooltip');

    // Create element on first render
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'chartjs-tooltip';
      tooltipEl.innerHTML = '<table></table>';
      document.body.appendChild(tooltipEl);
    }

    // Hide if no tooltip
    if (tooltipModel.opacity === 0) {
      tooltipEl.style.opacity = '0';
      return;
    }

    // Set caret Position
    tooltipEl.classList.remove('above', 'below', 'no-transform');
    if (tooltipModel.yAlign) {
      tooltipEl.classList.add(tooltipModel.yAlign);
    } else {
      tooltipEl.classList.add('no-transform');
    }

    function getBody(bodyItem: any) {
      return bodyItem.lines;
    }

    // Set Text
    if (tooltipModel.body) {
      let titleLines = tooltipModel.title || [];
      let bodyLines = tooltipModel.body.map(getBody);

      let innerHtml: any = '<thead>';

      titleLines.forEach(function (title: any) {
        innerHtml += '<tr><th>' + title + '</th></tr>';
      });
      innerHtml += '</thead><tbody>';

      bodyLines.forEach(function (body: any, i: any) {
        let colors = tooltipModel.labelColors[i];
        let style = 'background:' + colors.backgroundColor;
        style += '; border-color:' + colors.borderColor;
        style += '; border-width: 2px';
        let span = '<span style="' + style + '"></span>';
        innerHtml += '<tr><td>' + span + body + '</td></tr>';
      });
      innerHtml += '</tbody>';

      let tableRoot: any = tooltipEl.querySelector('table');
      // eslint-disable-next-line no-unsanitized/property
      tableRoot.innerHTML = innerHtml;
    }

    // `this` will be the overall tooltip
    let position = this._chart.canvas ? this._chart.canvas.getBoundingClientRect() : 0;

    // Display, position, and set styles for font
    tooltipEl.style.opacity = '1';
    tooltipEl.style.position = 'absolute';
    tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
    tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
    tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
    tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
    tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
    tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
    tooltipEl.style.pointerEvents = 'none';
    tooltipEl.style.backgroundColor = 'rgba(0,0,0,0.8)';
    tooltipEl.style.color = 'white';
    tooltipEl.style.zIndex = '999';
    tooltipEl.style.borderRadius = '4px';
  };

  componentDidMount() {
    this.chart = new Chart(this.state.id, {
      type: this.props.type,
      data: {
        labels: this.props.data.labels,
        datasets: this.props.data.datasets,
      },
      options: {
        ...this.props.options,
        tooltips: {
          enabled: false,
          custom: this.custom,
        },
      },
    });

    this.chart.generateLegend();
  }

  componentDidUpdate() {
    this.chart.data.datasets = this.props.data.datasets;
    this.chart.data.labels = this.props.data.labels;
    this.chart.update();
  }

  render() {
    return <canvas width='0' height='0' id={this.state.id} />;
  }
}

export default CustomChart;
